export default __webpack_public_path__ + "static/media/1-2-1.0d81083d.jpg";